import Preference, { type PreferenceScopeValue, type ScopeDefaults } from '../Preference';

type ListDefaults = {
  limit: number
  [key: string]: unknown
};

export default class ListPreference extends Preference {
  static defaults: ListDefaults = {
    limit: 0,
  };

  static changeDefault<K extends keyof ListDefaults>(name: K, value: ListDefaults[K]): typeof ListPreference {
    this.defaults[name] = value;
    return this;
  }

  constructor(values: PreferenceScopeValue, scopeName: string, scopeDefaults: ScopeDefaults = { __scopes: {} }) {
    super('List', values, scopeName, scopeDefaults);
  }

  set limit(value: number) {
    this.value.limit = value;
  }

  get limit(): number {
    return (this.value.limit as number) || ListPreference.defaults.limit;
  }
}
